import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { AlarmOverviewCollectionModel } from '@core/models';

@Injectable({
  providedIn: 'root',
})
export class AlarmsOverviewService {
  private readonly apiService = inject(ApiService);

  /** page_size=0 asks the backend for every open alarm in scope — the overview page's
   * filters (age bucket, date-range presets) run client-side, so it needs the full set. */
  getOverview(): Observable<AlarmOverviewCollectionModel> {
    return this.apiService.get('/alarm/alarms/overview', { page_size: 0 });
  }
}
